/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_Price_ChangedInputs */



/**
* | output |
* | --- |
* | "The price changed a moment ago – for example, someone else just took the free seat. Nothing was changed or charged. Please check the new price and confirm ag..." |
*
* @param {Seat_Change_Price_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_price_changed = /** @type {((inputs?: Seat_Change_Price_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Price_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Preis hat sich gerade geändert – zum Beispiel, weil jemand anderes den freien Platz belegt hat. Es wurde nichts geändert und nichts berechnet. Bitte prüfen Sie den neuen Preis und bestätigen Sie erneut.")
	return /** @type {LocalizedString} */ ("The price changed a moment ago – for example, someone else just took the free seat. Nothing was changed or charged. Please check the new price and confirm again.")
});